import React, { useEffect, useRef, useState } from 'react';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { makeStyles } from '@mui/styles';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
  badge: {
    fontSize: 30,
    fontWeight: 'bold',
  },
});

export default function HelperIcon() {
  const history = useHistory();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('lg'));

  const handleNavigate = () => {
    history.push('/help');
  };

  return (
    <div style={{ height: '4rem', width: isMobileView ? '3rem' : '4rem', marginRight: isMobileView ? '0px' : '5px' }}>
      <IconButton onClick={handleNavigate}>
        <HelpOutlineIcon sx={{ height: isMobileView ? '2rem' : '3rem', width: isMobileView ? '2rem' : '3rem',marginTop: isMobileView ? '4px' : '0px', }} />
      </IconButton>
    </div>
  );
}
